<template>
  <nav
    class="navbar navbar-vertical fixed-right navbar-expand-lg navbar-light bg-white"
    id="sidenav-main"
  >
    <div class="container-fluid">
      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar"></navbar-toggle-button>
      <router-link class="navbar-brand" to="/">
        <img :src="logo" class="navbar-brand-img" alt="logo" />
      </router-link>

      <slot name="mobile-right">
        <ul class="nav align-items-center d-lg-none">
          <a
            slot="title-container"
            class="nav-link nav-link-icon"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <b-icon
              icon="house-door"
              class="icon-mdi-account-outline-copy"
            ></b-icon>
          </a>

          <a
            slot="title-container"
            class="nav-link nav-link-icon"
            @click="openCurtain()"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <b-icon
              icon="person"
              class="icon-mdi-account-outline-copy"
            ></b-icon>
          </a>
          <a
            slot="title-container"
            class="nav-link nav-link-icon"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <b-icon
              v-b-toggle.sidebar-backdrop
              icon="bell"
              class="icon-mdi-account-outline-copy"
            ></b-icon>
          </a>
        </ul>
      </slot>
      <slot></slot>
      <div
        @click="closeSidebar"
        id="dark-backdrop-menu"
        class="dark-backdrop"
      ></div>

      <div
        v-show="$sidebar.showSidebar"
        class="navbar-collapse collapse show"
        id="sidenav-collapse-main"
      >
        <div class="navbar-collapse-header d-lg-none">
          <div class="row">
            <div class="col-10 collapse-brand">
              <router-link to="/">
                <img :src="logo" />
              </router-link>
            </div>
            <div class="col-2 collapse-close">
              <navbar-toggle-button
                @click.native="closeSidebar"
              ></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"></slot>
        </ul>
        <!--Divider-->
        <hr class="my-3" />
        <!--Heading-->
      </div>
    </div>
  </nav>
</template>

<script>
import NavbarToggleButton from "@/components/NavbarToggleButton";
import http from "@/httpservices/HttpService"

export default {
  name: "sidebar",
  components: {
    NavbarToggleButton,
  },

  props: {
    logo: {
      type: String,
      default: "/img/brand/logo.png",
      description: "Sidebar app logo",
    },

    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
  },

  data() {
    return {
      activeNotifications: false,
      showMenu: false,
    };
  },

  provide() {
    return {
      autoClose: this.autoClose,
    };
  },

  mounted() {
    // this.getProfile();
  },

  methods: {
    openCurtain() {
      document.getElementById("CurtainMenu").style.height = "75%";
      document.getElementById("dark-backdrop").style.display = "block";
      document.getElementById("dark-backdrop").style.height = "100%";
    },

    closeSidebar() {
      document.getElementById("dark-backdrop-menu").style.display = "none";
      document.getElementById("dark-backdrop-menu").style.height = "0";
      this.$sidebar.displaySidebar(false);
    },

    showSidebar() {
      document.getElementById("dark-backdrop-menu").style.display = "block";
      document.getElementById("dark-backdrop-menu").style.height = "100%";
      this.$sidebar.displaySidebar(true);
    },
  },

  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
